module.exports = __webpack_public_path__ + "img/stamp-diy.8190a31c.png";